import { create } from "zustand";
import { isModified, saveSnapshot, useProjectStore } from "./projectStore";

/**
 * Tek proje açık (Cem 2026-09-29, AutoCAD davranışı): yeni proje / aç / dosyadan aç / örnek / kapat (✕) / çıkış eylemleri
 * önce açık projeyi kapatır. Açılıştan ya da son açık kayıttan bu yana değişiklik varsa (`modified`; otomatik kayıt bunu
 * temizlemez) "Değişiklikler kaydedilsin mi?" — Kaydet / Kaydetme / İptal. Salt okunur ve paylaşım projeleri hiç sormaz.
 */
interface GuardState { pending: (() => void) | null; onCancel: (() => void) | null; ask(action: () => void, onCancel?: () => void): void; clear(): void }
export const useUnsavedGuard = create<GuardState>((set) => ({
  pending: null, onCancel: null,
  ask: (action, onCancel) => set({ pending: action, onCancel: onCancel ?? null }),
  clear: () => set({ pending: null, onCancel: null }),
}));

/** Projeyi hemen kapatır; bekleyen otomatik kayıt (dirty) varsa o anki hâli önce depoya yazar. */
export function finishClose(): void {
  const s = useProjectStore.getState();
  if (s.project && s.dirty && !s.readOnly) void saveSnapshot(s);
  s.closeProject();
}

/** Açık projeyi kapatıp `then`i çalıştırır; değişiklik varsa önce diyaloğu açar (İptal → hiçbir şey olmaz). */
export function closeCurrent(then: () => void = () => undefined): void {
  if (isModified()) { useUnsavedGuard.getState().ask(then); return; }
  finishClose();
  then();
}

/**
 * Adres başka bir projeyi gösteriyor (tarayıcı geri/ileri, elle yazılan adres): açık proje değiştiyse önce sorulur. Kaydet /
 * Kaydetme → proje kapanır, sayfa (proje yok) adresteki projeyi kendisi yükler · İptal → `stay` (adres açık projeye döner).
 * Değişiklik yoksa bekleyen otomatik kayıt yazılır ve `open` hemen çalışır.
 */
export function switchFromUrl(open: () => void, stay: () => void): void {
  const s = useProjectStore.getState();
  if (isModified(s)) { if (!useUnsavedGuard.getState().pending) useUnsavedGuard.getState().ask(() => undefined, stay); return; }
  if (s.project && s.dirty && !s.readOnly) void saveSnapshot(s);
  open();
}
